import { render, staticRenderFns } from "./EditClinicChk.vue?vue&type=template&id=daa99b06&scoped=true"
import script from "./EditClinicChk.vue?vue&type=script&lang=js"
export * from "./EditClinicChk.vue?vue&type=script&lang=js"
import style0 from "./EditClinicChk.vue?vue&type=style&index=0&id=daa99b06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa99b06",
  null
  
)

export default component.exports